import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailHeaderPriceCss from '../../assets/header/header-price.module.scss';

const HeaderPrice: FC = () => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      price,
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return null;
  }

  if (!price) {
    return null;
  }

  return (
    <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice}>
      <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice__value}>
        {price}
      </div>
      <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice__label}>
        <FormattedMessage defaultMessage="hour rate" />
      </div>
    </div>
  );
};

export { HeaderPrice };
